import React from 'react';
import {
  View,
  Text,
  ScrollView,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
} from 'react-native';
import { router } from 'expo-router';
import { ArrowLeft } from 'lucide-react-native';
import { useTheme } from '@/contexts/ThemeContext';

export default function PoliticaPrivacidadeScreen() {
  const { colors } = useTheme();

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    backButton: {
      marginRight: 16,
    },
    headerTitle: {
      fontSize: 18,
      fontFamily: 'Inter-SemiBold',
      color: colors.text,
    },
    content: {
      flex: 1,
      paddingHorizontal: 16,
      paddingVertical: 20,
    },
    title: {
      fontSize: 24,
      fontFamily: 'Inter-Bold',
      color: colors.text,
      marginBottom: 8,
    },
    lastUpdate: {
      fontSize: 14,
      fontFamily: 'Inter-Medium',
      color: colors.textSecondary,
      marginBottom: 20,
    },
    paragraph: {
      fontSize: 16,
      fontFamily: 'Inter-Regular',
      color: colors.text,
      lineHeight: 24,
      marginBottom: 16,
    },
    sectionTitle: {
      fontSize: 18,
      fontFamily: 'Inter-SemiBold',
      color: colors.text,
      marginTop: 20,
      marginBottom: 12,
    },
    bulletPoint: {
      fontSize: 16,
      fontFamily: 'Inter-Regular',
      color: colors.text,
      lineHeight: 24,
      marginBottom: 8,
      marginLeft: 16,
    },
    email: {
      fontSize: 16,
      fontFamily: 'Inter-SemiBold',
      color: colors.primary,
    },
  });

  const getCurrentDate = () => {
    const now = new Date();
    return now.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => router.back()}
          activeOpacity={0.7}
        >
          <ArrowLeft size={24} color={colors.text} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Política de Privacidade</Text>
      </View>

      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        <Text style={styles.title}>Política de Privacidade</Text>
        <Text style={styles.lastUpdate}>
          Última atualização: 06 de janeiro de 2026
        </Text>

        <Text style={styles.paragraph}>
          Bem-vindo(a) ao Põe no Racha. A sua privacidade é importante para nós. Esta política de privacidade explica como coletamos, usamos, compartilhamos e protegemos suas informações pessoais.
        </Text>

        <Text style={styles.sectionTitle}>1. Informações que Coletamos</Text>
        <Text style={styles.paragraph}>
          Coletamos as seguintes informações para fornecer e melhorar nossos serviços:
        </Text>
        <Text style={styles.bulletPoint}>
          • Informações de Cadastro: Quando você cria uma conta, coletamos seu nome, endereço de e-mail e informações de autenticação.
        </Text>
        <Text style={styles.bulletPoint}>
          • Conteúdo Gerado pelo Usuário: Coletamos os dados que você cria dentro do aplicativo, como nomes de rachas, despesas, valores, participantes e chaves Pix.
        </Text>
        <Text style={styles.bulletPoint}>
          • Dados de Uso: Podemos coletar informações sobre como você interage com nosso aplicativo para nos ajudar a identificar problemas e melhorar a experiência.
        </Text>

        <Text style={styles.sectionTitle}>2. Como Usamos Suas Informações</Text>
        <Text style={styles.paragraph}>
          Utilizamos as informações coletadas para:
        </Text>
        <Text style={styles.bulletPoint}>
          • Operar e manter o serviço de divisão de despesas.
        </Text>
        <Text style={styles.bulletPoint}>
          • Personalizar sua experiência no aplicativo.
        </Text>
        <Text style={styles.bulletPoint}>
          • Comunicar com você sobre sua conta ou atualizações do serviço.
        </Text>
        <Text style={styles.bulletPoint}>
          • Analisar o uso do aplicativo para fins de melhoria.
        </Text>

        <Text style={styles.sectionTitle}>3. Compartilhamento de Informações</Text>
        <Text style={styles.paragraph}>
          Nós não compartilhamos suas informações pessoais com terceiros, exceto nas seguintes circunstâncias:
        </Text>
        <Text style={styles.bulletPoint}>
          • Com seu consentimento explícito.
        </Text>
        <Text style={styles.bulletPoint}>
          • Para cumprir com obrigações legais.
        </Text>
        <Text style={styles.bulletPoint}>
          • Para proteger nossos direitos, privacidade, segurança ou propriedade.
        </Text>

        <Text style={styles.sectionTitle}>4. Seus Direitos</Text>
        <Text style={styles.paragraph}>
          Você tem o direito de acessar, corrigir ou excluir suas informações pessoais a qualquer momento através das configurações do seu perfil no aplicativo.
        </Text>

        <Text style={styles.sectionTitle}>5. Publicidade e Cookies de Terceiros</Text>
        <Text style={styles.paragraph}>
          Este aplicativo exibe anúncios fornecidos pelo Google AdSense e AdMob. O Google e seus parceiros utilizam cookies, beacons da web, endereços IP e outras tecnologias similares para coletar informações sobre sua navegação e interação com o aplicativo, com o objetivo de exibir anúncios relevantes e personalizados.
        </Text>
        <Text style={styles.paragraph}>
          As informações coletadas pelo Google podem incluir:
        </Text>
        <Text style={styles.bulletPoint}>
          • Identificadores de dispositivo e informações técnicas do seu aparelho.
        </Text>
        <Text style={styles.bulletPoint}>
          • Dados sobre sua interação com anúncios e conteúdo.
        </Text>
        <Text style={styles.bulletPoint}>
          • Informações de localização aproximada baseadas em IP.
        </Text>
        <Text style={styles.paragraph}>
          Para mais informações sobre como o Google utiliza dados quando você usa nosso aplicativo, acesse: https://policies.google.com/technologies/partner-sites
        </Text>
        <Text style={styles.paragraph}>
          Você pode gerenciar suas preferências de anúncios personalizados acessando: https://adssettings.google.com
        </Text>

        <Text style={styles.sectionTitle}>6. Consentimento para Uso de Cookies</Text>
        <Text style={styles.paragraph}>
          Ao utilizar este aplicativo, você consente com o uso de cookies e tecnologias similares conforme descrito nesta política. Terceiros, incluindo o Google, podem inserir cookies no navegador dos usuários para fins de análise e veiculação de anúncios.
        </Text>

        <Text style={styles.sectionTitle}>7. Contato</Text>
        <Text style={styles.paragraph}>
          Se você tiver alguma dúvida sobre esta política de privacidade, entre em contato conosco pelo e-mail: <Text style={styles.email}>poenoracha@gmail.com</Text>
        </Text>
      </ScrollView>
    </SafeAreaView>
  );
}
